module.exports = __webpack_public_path__ + "src/assets/img/product-laka-1.e09fdf45.png";